<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['PM']['RS']}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'SM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['SAG']}}
                                                <i @click="setSortTable('SM')" :class="setSortLogo('SM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['WLRPT']['MAG']}}
                                                <i @click="setSortTable('MA')" :class="setSortLogo('MA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BILL'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['BILL']}}
                                                <i @click="setSortTable('BILL')" :class="setSortLogo('BILL')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['BN']}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'IN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACT']['IN']}}
                                                <i @click="setSortTable('IN')" :class="setSortLogo('IN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'SOD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['SOD']}}
                                                <i @click="setSortTable('SOD')" :class="setSortLogo('SOD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'DPT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AG']['PT']}}
                                                <i @click="setSortTable('DPT')" :class="setSortLogo('DPT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CUR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACT']['CUR']}}
                                                <i @click="setSortTable('CUR')" :class="setSortLogo('CUR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GGR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['GGR']}}
                                                <i @click="setSortTable('GGR')" :class="setSortLogo('GGR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MTNF'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['AG']['MTNF']}}
                                                <i @click="setSortTable('MTNF')" :class="setSortLogo('MTNF')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PDR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['PDR']}}
                                                <i @click="setSortTable('PDR')" :class="setSortLogo('PDR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['TR']}}
                                                <i @click="setSortTable('TR')" :class="setSortLogo('TR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PFSR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['PFSR']}}
                                                <i @click="setSortTable('PFSR')" :class="setSortLogo('PFSR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'AGP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACM']['AGP']}}
                                                <i @click="setSortTable('AGP')" :class="setSortLogo('AGP')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'SMMF'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACT']['SMMF']}}
                                                <i @click="setSortTable('SMMF')" :class="setSortLogo('SMMF')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CFA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['ACT']['CR']}}
                                                <i @click="setSortTable('CFA')" :class="setSortLogo('CFA')" class="sortlogo"></i>
                                            </template>

                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('OVW', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['ACM']['OVW']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :flat="true"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :disable-branch-nodes="false"
                                                  :placeholder="this.utilGetDDLanguage('PM.AGI')"
                                                  :limit="1"
                                                  :limitText="count => `+${count}`"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  v-model="arr_FV['AGI']"
                                                  @input="AgentGroupChangefs" />
                            </div>

                            <div>
                                <span class='searchLabel'>{{getLanguage["AFF"]["PD"]}} :</span>
                                <vue-monthly-picker v-model="arr_FV['DR']"
                                                    :clearOption="false"
                                                    dateFormat="YYYY-MMM"
                                                    selectedBackgroundColor="blue"
                                                    @selected="ChangeToMonth">
                                </vue-monthly-picker>
                            </div>


                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['RS']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_memberpromotionstatus"
                                            :placeholder="this.utilGetDDLanguage('PM.RS')"
                                            v-model="arr_FV['RS']" />
                            </div>


                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('AFF.C')"
                                            v-model="arr_FV['CI']"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['ACM']['OVL']}}</strong>
                    <div>
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <!--<CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>-->
                    </div>
                </header>

                <div class="my-1" v-if="backURL != null && backURL == 1">
                    <span style="cursor: pointer;" @click="getSMLevelStorage()">
                        {{this.getLanguage['ACM']['OVSM']}}
                        <i class="fas fa-caret-right mx-2"></i>
                    </span>
                    <span><span style="cursor: default; pointer-events: none"> {{this.getLanguage['ACM']['OVMA']}}</span></span>
                </div>
                <div class="my-1" v-else-if="backURL == 2">
                    <span style="cursor: pointer;" @click="getSMLevelStorage()">
                        {{this.getLanguage['ACM']['OVSM']}}
                        <i class="fas fa-caret-right mx-2"></i>
                    </span>
                    <span style="cursor: pointer;" @click="getMALevelStorage()">
                        {{this.getLanguage['ACM']['OVMA']}}
                        <i class="fas fa-caret-right mx-2"></i>
                    </span>
                    <span><span style="cursor: default; pointer-events: none"> {{this.getLanguage['ACM']['OVAG']}}</span></span>
                </div>
                <div class="my-1" v-else-if="backURL == 3">
                    <span style="cursor: pointer;" @click="getMALevelStorage()">
                        {{this.getLanguage['ACM']['OVMA']}}
                        <i class="fas fa-caret-right mx-2"></i>
                    </span>
                    <span><span style="cursor: default; pointer-events: none"> {{this.getLanguage['ACM']['OVAG']}}</span></span>
                </div>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="34">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                            <tr v-if="arr_PromotionReportListTotal.length == 0"><td colspan="100%">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in arr_PromotionReportListTotal" class="reportTotal">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        <a style="cursor: pointer;" @click="ShowDetails(data.ISOC)">{{getLanguage['WLRPT']['VA']}}</a>
                                    </template>
                                    <template v-else-if="header == 'RS'">

                                    </template>
                                    <template v-else-if="header == 'SM'">

                                    </template>
                                    <template v-else-if="header == 'MA'">

                                    </template>
                                    <template v-else-if="header == 'BILL'">

                                    </template>

                                    <template v-else-if="header == 'GN'">

                                    </template>
                                    <template v-else-if="header == 'IN'">

                                    </template>
                                    <template v-else-if="header == 'SOD'">

                                    </template>
                                    <template v-else-if="header == 'DPT'">

                                    </template>
                                    <template v-else-if="header == 'CUR'">
                                        {{data.ISOC }}
                                    </template>
                                    <template v-else-if="header == 'GGR'">
                                        {{formatNumber(data.GGR, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'MTNF'">
                                        {{formatNumber(data.MTNF, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'PDR'">
                                        {{formatNumber(data.PDR, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'TR'">
                                        {{formatNumber(data.TR, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'PFSR'">
                                        {{formatNumber(data.PDR, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'AGP'">
                                        {{formatNumber(data.AGP, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'SMMF'">
                                        {{formatNumber(data.SMMF, 2, data.ISOC, false)}}
                                    </template>
                                    <template v-else-if="header == 'CFA'">
                                        {{formatNumber(data.CFA, 2, data.ISOC, false)}}
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['SAG']}}
                                        <i @click="setSortTable('SM')" :class="setSortLogo('SM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['MAG']}}
                                        <i @click="setSortTable('MA')" :class="setSortLogo('MA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BILL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['BILL']}}
                                        <i @click="setSortTable('BILL')" :class="setSortLogo('BILL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['BN']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['IN']}}
                                        <i @click="setSortTable('IN')" :class="setSortLogo('IN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SOD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['SOD']}}
                                        <i @click="setSortTable('SOD')" :class="setSortLogo('SOD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['PT']}}
                                        <i @click="setSortTable('DPT')" :class="setSortLogo('DPT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CUR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['CUR']}}
                                        <i @click="setSortTable('CUR')" :class="setSortLogo('CUR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GGR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['GGR']}}
                                        <i @click="setSortTable('GGR')" :class="setSortLogo('GGR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MTNF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['MTNF']}}
                                        <i @click="setSortTable('MTNF')" :class="setSortLogo('MTNF')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PDR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['PDR']}}
                                        <i @click="setSortTable('PDR')" :class="setSortLogo('PDR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['TR']}}
                                        <i @click="setSortTable('TR')" :class="setSortLogo('TR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PFSR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['PFSR']}}
                                        <i @click="setSortTable('PFSR')" :class="setSortLogo('PFSR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['AGP']}}
                                        <i @click="setSortTable('AGP')" :class="setSortLogo('AGP')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SMMF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['SMMF']}}
                                        <i @click="setSortTable('SMMF')" :class="setSortLogo('SMMF')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CFA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['CR']}}
                                        <i @click="setSortTable('CFA')" :class="setSortLogo('CFA')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' style="min-height: 100px;">
                        <thead>
                            <tr>
                                <th colspan="34">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                            <tr v-if="arr_PromotionReportListTotal.length == 0"><td colspan="100%">{{this.getLanguage['GL']['NR']}}</td></tr>
                            <tr v-for="(data,index) in arr_PromotionReportListTotal" class="reportTotal">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        <a style="cursor: pointer;" @click="ShowDetails(data.ISOC)">{{getLanguage['WLRPT']['VA']}}</a>
                                    </template>
                                    <template v-else-if="header == 'RS'">

                                    </template>
                                    <template v-else-if="header == 'SM'">

                                    </template>
                                    <template v-else-if="header == 'MA'">

                                    </template>
                                    <template v-else-if="header == 'BILL'">
                                       
                                    </template>
                                    <template v-else-if="header == 'GN'">

                                    </template>
                                    <template v-else-if="header == 'IN'">

                                    </template>
                                    <template v-else-if="header == 'SOD'">

                                    </template>
                                    <template v-else-if="header == 'DPT'">

                                    </template>
                                    <template v-else-if="header == 'CUR'">
                                        {{data.ISOC }}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'GGR'">
                                        {{formatNumber(data.GGR, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'MTNF'">
                                        {{formatNumber(data.MTNF, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'PDR'">
                                        {{formatNumber(data.PDR, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'TR'">
                                        {{formatNumber(data.TR, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'PFSR'">
                                        {{formatNumber(data.PDR, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'AGP'">
                                        {{formatNumber(data.AGP, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'SMMF'">
                                        {{formatNumber(data.SMMF, 2, data.ISOC, false)}}
                                    </template>
                                    <template style="text-align: right;" v-else-if="header == 'CFA'">
                                        {{formatNumber(data.CFA, 2, data.ISOC, false)}}
                                    </template>
                                </td>
                            </tr>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['SAG']}}
                                        <i @click="setSortTable('SM')" :class="setSortLogo('SM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLRPT']['MAG']}}
                                        <i @click="setSortTable('MA')" :class="setSortLogo('MA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BILL'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['BILL']}}
                                        <i @click="setSortTable('BILL')" :class="setSortLogo('BILL')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['BN']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['IN']}}
                                        <i @click="setSortTable('IN')" :class="setSortLogo('IN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SOD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['SOD']}}
                                        <i @click="setSortTable('SOD')" :class="setSortLogo('SOD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DPT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['PT']}}
                                        <i @click="setSortTable('DPT')" :class="setSortLogo('DPT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CUR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['CUR']}}
                                        <i @click="setSortTable('CUR')" :class="setSortLogo('CUR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GGR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['GGR']}}
                                        <i @click="setSortTable('GGR')" :class="setSortLogo('GGR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MTNF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['AG']['MTNF']}}
                                        <i @click="setSortTable('MTNF')" :class="setSortLogo('MTNF')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PDR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['PDR']}}
                                        <i @click="setSortTable('PDR')" :class="setSortLogo('PDR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['TR']}}
                                        <i @click="setSortTable('TR')" :class="setSortLogo('TR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PFSR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['PFSR']}}
                                        <i @click="setSortTable('PFSR')" :class="setSortLogo('PFSR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'AGP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACM']['AGP']}}
                                        <i @click="setSortTable('AGP')" :class="setSortLogo('AGP')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SMMF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['SMMF']}}
                                        <i @click="setSortTable('SMMF')" :class="setSortLogo('SMMF')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CFA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['ACT']['CR']}}
                                        <i @click="setSortTable('CFA')" :class="setSortLogo('CFA')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_PromotionReportList == null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_PromotionReportList" v-if="bool_showDetails && str_showDetails == data.ISOC">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ index+1 }}
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <span class="grid-line">{{ renderStatus(data.RS) }}</span>
                                </template>
                                <template v-else-if="header == 'SM'">
                                    <router-link :to="{
                            path: '/R/TWLBAG',
                            query: {
                              agi: data.GN,
                              bool_showMaintainInfo: true
                            }
                          }">
                                        {{ data.GN }}
                                    </router-link>
                                </template>
                                <template v-else-if="header == 'MA'">

                                </template>
                                <template v-else-if="header == 'BILL'">

                                </template>
                                <template v-else-if="header === 'GN'">

                                </template>
                                <template v-else-if="header == 'IN'">
                                    <router-link :to="{
                                                 path: '/AGS/AGD', query:{agi: data.GN}}">
                                        {{data.IN }}
                                    </router-link>
                                </template>
                                <template v-else-if="header == 'SOD'">
                                    {{data.SOD }}
                                </template>
                                <template v-else-if="header == 'DPT'">
                                    {{formatNumber(data.PT,2)}} %
                                </template>
                                <template v-else-if="header == 'CUR'">
                                    {{data.ISOC }}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'GGR'">
                                    {{formatNumber(data.GGR, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'MTNF'">
                                    {{formatNumber(data.MTNF, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'PDR'">
                                    {{formatNumber(data.PDR, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'TR'">
                                    {{formatNumber(data.TR, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'PFSR'">
                                    {{formatNumber(data.PDR, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'AGP'">
                                    {{formatNumber(data.AGP, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'SMMF'">
                                    {{formatNumber(data.SMMF, 2, data.ISOC, false)}}
                                </template>
                                <template style="text-align: right;" v-else-if="header == 'CFA'">
                                    {{formatNumber(data.CFA, 2, data.ISOC, false)}}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constPromotionStatus, constRejectReasonP, constPromotionSystemApproved, constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker';
    import VueMonthlyPicker from 'vue-monthly-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))
    import $ from 'jquery'
    import draggable from 'vuedraggable';


    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            VueMonthlyPicker,
            customtreeselect,
            Loading,
            draggable
        },

        data() {
            return {
                bool_showDetails: false,
                bool_fingerPrintLoading: [], // fingerprint/lastSystemID
                bool_showSearchBar: true,
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                SMList: null,
                str_tableSortBy: "GN", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                ddCurrencyList: null,
                searchCurrency: null,
                bool_isSearchCC: false,
                selectedAgent: null,
                backURL: null,
                str_yearmonth: null,
                arr_FV: {
                    "DR": null,
                    "RS": null,
                    "TT": 3,
                    "AGI": null,
                    "CI": null,
                    "RI": "",
                    "AT": null
                },
                arr_PromotionReportList: [],
                arr_PromotionReportListTotal: [],

                dd_memberpromotionstatus: [],
                dd_memberhousestatus: [],
                dd_currency: [],
                dd_agentgroup: [],
                constAccessType: constAccessType,

                searchAgi: "",
                defaultReportHeaders: ['NO', 'RS','SM','MA','BILL', 'GN', 'IN', 'DPT', 'SOD', 'CUR', 'SMMF', 'AGP', 'MTNF', 'PDR', 'TR', 'GGR', 'PFSR', 'CFA'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                strAGI: "",
                rfrAGI: "",
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        methods: {


            getVDP() {
                this.dd_memberpromotionstatus = [
                {
                    id: "2",
                    label: this.getLanguage['ACM']['SO']
                },
                {
                    id: "4",
                    label: this.getLanguage['ACM']['NS']
                }
                ];

                this.dd_memberhousestatus = [
                    {
                        id: "0",
                        label: this.getLanguage['WLRPT']['SA']
                    },
                    {
                        id: "1",
                        label: this.getLanguage['ACM']['NH']
                    }
                ];

            },
            newSearch() {
                if (this.$route.path !== "/R/OVW" || Object.keys(this.$route.query).length !== 0) {
                    this.$router.replace({ path: "/R/OVW", query: {} });
                }
                this.$refs.search.focus();
                if (this.searchCurrency != null) {
                    this.bool_isSearchCC = true;
                } else
                {
                    this.bool_isSearchCC = false;
                }
                this.getPromotionReportList();
            },
            ShowDetails(currency) {
                if (this.str_showDetails != currency) {
                    this.str_showDetails = currency;
                    this.bool_showDetails = true;
                    sessionStorage.setItem('OVW_Filter_ISOC', currency);
                }
                else {
                    this.bool_showDetails = !this.bool_showDetails;
                }
                this.resizeTableHead();
            },
            setSortTable(SV) { //SV = Sort Value
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;

                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.disableAgentGroupLevel();
                            } else {
                                that.arr_FV['AT'] = null;
                            }
                        }
                    });

            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchAgi) {
                    agi = this.searchAgi;
                }
                // for selecting brand and filter currency (for SSA,SA,MA )
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
                // for agent level and filter currency (no brand selection, for agent and sub agent level)
                var current_agi = this.getUserInfo.AGI;
                if (this.getUserInfo.AT >= 3)
                {
                    this.getDataApi(`/api/dd/cur/` + current_agi,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
                }

            },
            AgentGroupChangefs(value) {
                if (
                    value.length > 0 &&
                    (value[0].split("-")[0] === "1" || value[0].split("-")[0] === "0")
                ) {
                    this.arr_FV["AT"] = 1;
                } else if (
                    value.length > 0 &&
                    value[0].split("-")[0] === "2"
                ) {
                    this.arr_FV["AT"] = 2;
                } else if (
                    value.length > 0 &&
                    value[0].split("-")[0] === "3"
                ) {
                    this.arr_FV["AT"] = 3;
                }
                else {
                    this.arr_FV["AT"] = 0;
                }

                console.log('Agent', value);

                this.arr_FV["AGI_csv"] = null;


                var temp = "";
                if (value != undefined) {
                    //var agi = 0;
                    if (value != "") {
                        //agi = value.split("-")[1];
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.searchAgi = temp;
                        this.arr_FV["AGI_csv"] = temp;


                    } else {
                        this.searchAgi = 0;
                    }
                } else {
                    this.searchAgi = 0;
                    this.arr_FV['AGI_csv'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
                this.selectedAgent = value;

                this.getDropdownList();
                console.log(this.arr_FV['AGI_csv']);
                var that = this;

            },
            getLinkUrl() {
                var link = '/R/OVW';
                sessionStorage.setItem(link, this.$route.path);
                return link;
            },
            disableAgentGroupLevel() {
                var that = this;
                if (that.selectedAgent != null && that.selectedAgent.length > 0) {
                    var selectedAgent = that.selectedAgent[0].split("-")[0];
                    for (var j = 0; j < that.dd_agentgroup.length; j++) {
                        var itemLevel = that.dd_agentgroup[j].id.split("-")[0];

                        if (selectedAgent != itemLevel && itemLevel == "0") {
                            that.dd_agentgroup[j].isDisabled = true;
                        }

                        if (that.dd_agentgroup[j].children && that.dd_agentgroup[j].children.length > 0) {
                            for (var k = 0; k < that.dd_agentgroup[j].children.length; k++) {
                                var itemLevel1 = that.dd_agentgroup[j].children[k].id.split("-")[0];

                                if (selectedAgent != itemLevel1 && itemLevel1 == "1") {
                                    that.dd_agentgroup[j].children[k].isDisabled = true;
                                }

                                if (that.dd_agentgroup[j].children[k].children && that.dd_agentgroup[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.dd_agentgroup[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.dd_agentgroup[j].children[k].children[l].id.split("-")[0];

                                        if (selectedAgent != itemLevel2 && itemLevel2 == "2") {
                                            that.dd_agentgroup[j].children[k].children[l].isDisabled = true;
                                        }

                                        if (that.dd_agentgroup[j].children[k].children[l].children && that.dd_agentgroup[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.dd_agentgroup[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.dd_agentgroup[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (selectedAgent != itemLevel3 && itemLevel3 == "3") {
                                                    that.dd_agentgroup[j].children[k].children[l].children[m].isDisabled = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            readGetParam() {
                const agiString = this.$route.query.agi;
                const goValue = this.$route.query.AT;


                if (!agiString || !goValue) return;

                const selectedValues = [];


                const combined = `${goValue}-${agiString}`;

                if (this.dd_agentgroup != null && this.dd_agentgroup.length == 1)
                {
                    if (this.dd_agentgroup[0].id.split("-")[0] == "0") {
                        var SMLevel_Arr = this.dd_agentgroup[0].children

                        if (this.$route.query.AT == 1)
                        {
                            SMLevel_Arr.forEach(child => {

                                if (child.id != null && child.id.split("-")[1] === agiString) {

                                    if (child.children && Array.isArray(child.children)) {
                                        child.children.forEach(grandchild => {

                                            selectedValues.push(grandchild.id);
                                        });
                                    }
                                }
                            });

                        } else if (this.$route.query.AT == 2)
                        {

                            SMLevel_Arr.forEach(child => {
                                const MALevel_Arr = child.children && Array.isArray(child.children)
                                    ? child.children
                                    : [];
                                MALevel_Arr.forEach(childMA => {
                                    if (childMA.id != null && childMA.id.split("-")[1] === agiString) {
                                        if (childMA.children && Array.isArray(childMA.children)) {
                                            childMA.children.forEach(grandchild => {
                                                selectedValues.push(grandchild.id);
                                            });
                                        }
                                    }
                                });
                            });


                        }



                    } else if (this.dd_agentgroup[0].id.split("-")[0] == "1") {

                    } else if (this.dd_agentgroup[0].id.split("-")[0] == "2")
                    {

                    }
                }



                this.arr_FV['AGI'] = selectedValues;
                this.AgentGroupChangefs(this.arr_FV['AGI']);
                this.getPromotionReportList();
                if (this.$route.query.go != null && (this.$route.query.go == 0 || this.$route.query.go == 1)) {
                    this.backURL = 1;
                } else if (this.$route.query.go == 2 && this.backURL == 1) {
                    this.backURL = 2;
                } else {
                    this.backURL = 3;
                }




            },
            ChangeToMonth() {
                this.str_yearmonth = moment(this.arr_FV['DR']).format('MMM YYYY');
            },
            getPromotionReportList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(0, 0, this.str_tableSortBy, this.bool_isSort);


                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    if (this.arr_FV['DR'] != null) {
                        var YearMonthForCSharp = this.parseDateToJsonString(this.arr_FV['DR']);
                        path += ("&f.PTS_from=" + YearMonthForCSharp);
                    }

                    if (this.arr_FV["CI"] != null) {
                        var temp_ = "";
                        for (var x = 0; x < this.arr_FV.CI.length; x++) {
                            if (x != 0) {
                                temp_ += ",";
                            }
                            temp_ += this.arr_FV.CI[x];
                        }
                        path += ("&f.CI_csv=" + temp_);
                    }

                    if (this.arr_FV["RS"] != null) {
                        path += ("&f.RS=" + this.arr_FV["RS"]);
                    }

                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                        console.log('trigger AGI_csv');
                    } else {
                        console.log('trigger AT 0');
                        this.arr_FV['AT'] = 0;
                    }

                    if (this.arr_FV['AT']) {
                        console.log('trigger AT', this.arr_FV['AT']);
                        path += ("&f.AT=" + this.arr_FV["AT"]);
                    } else if (this.$route.query.go != null) {
                        console.log('trigger $route');
                        this.arr_FV["AT"] = parseInt(this.$route.query.go, 10) + 1;
                        path += ("&f.AT=" + this.arr_FV["AT"]);
                    }

                    console.log('this.arr_FV["AT"]', this.arr_FV["AT"]);
                    if (this.arr_FV["AT"] == null || this.arr_FV["AT"] == 0 || this.arr_FV["AT"] == 1) {
                        console.log('setSM');
                        this.setSMLevelStorage();
                    } else if (this.arr_FV["AT"] == 2) {
                        console.log('setMA');
                        this.setMALevelStorage();
                    }




                }
                if (this.searchCurrency) {
                    path += "&f.CICI=" + this.searchCurrency;
                } else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CICI=" + localStorage.getItem('CCUSD');
                }



                this.getDataApi(`/api/reports/accounting/ovwreport?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_PromotionReportList = d.R1;
                            that.arr_PromotionReportListTotal = d.R2;
                            that.resizeTableHead();
                        }
                    });
            },
            setSMLevelStorage() {

                sessionStorage.removeItem('OVWL1_Filter_Month');
                sessionStorage.removeItem('OVWL1_Filter_CI');
                sessionStorage.removeItem('OVWL1_Filter_RS');
                sessionStorage.removeItem('OVWL1_Filter_AGI_csv');
                sessionStorage.removeItem('OVWL1_Filter_AGI');
                sessionStorage.removeItem('OVWL1_Filter_AT');
                sessionStorage.removeItem('OVWL1_Filter_T');

                if (this.arr_FV['DR'] != null) {
                    sessionStorage.setItem('OVWL1_Filter_Month', this.parseDateToJsonString(this.arr_FV['DR']));
                }

                if (this.arr_FV["CI"] != null) {
                    sessionStorage.setItem('OVWL1_Filter_CI', this.arr_FV["CI"]);
                }

                if (this.arr_FV["RS"] != null) {
                    sessionStorage.setItem('OVWL1_Filter_RS', this.arr_FV["RS"]);
                }


                if (this.arr_FV["AGI_csv"]) {
                    sessionStorage.setItem('OVWL1_Filter_AGI_csv', this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                }

                if (this.arr_FV["AGI"]) {
                    sessionStorage.setItem("OVWL1_Filter_AGI", this.arr_FV["AGI"]);
                }

                if (this.arr_FV['AT']) {
                    sessionStorage.setItem('OVWL1_Filter_AT', this.arr_FV["AT"]);
                }

                sessionStorage.setItem('OVWL1_Filter_T', true);
            },
            setMALevelStorage() {

                sessionStorage.removeItem('OVWL2_Filter_Month');
                sessionStorage.removeItem('OVWL2_Filter_CI');
                sessionStorage.removeItem('OVWL2_Filter_RS');
                sessionStorage.removeItem('OVWL2_Filter_AGI_csv');
                sessionStorage.removeItem('OVWL2_Filter_AGI');
                sessionStorage.removeItem('OVWL2_Filter_AT');
                sessionStorage.removeItem('OVWL2_Filter_T');

                if (this.arr_FV['DR'] != null) {
                    sessionStorage.setItem('OVWL2_Filter_Month', this.parseDateToJsonString(this.arr_FV['DR']));
                }

                if (this.arr_FV["CI"] != null) {
                    sessionStorage.setItem('OVWL2_Filter_CI', this.arr_FV["CI"]);
                }

                if (this.arr_FV["RS"] != null) {
                    sessionStorage.setItem('OVWL2_Filter_RS', this.arr_FV["RS"]);
                }


                if (this.arr_FV["AGI_csv"]) {
                    sessionStorage.setItem('OVWL2_Filter_AGI_csv', this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                }

                if (this.arr_FV["AGI"]) {
                    sessionStorage.setItem("OVWL2_Filter_AGI", this.arr_FV["AGI"]);
                }

                if (this.arr_FV['AT']) {
                    sessionStorage.setItem('OVWL2_Filter_AT', this.arr_FV["AT"]);
                }

                sessionStorage.setItem('OVWL2_Filter_T', true);
            },
            getSMLevelStorage() {

                this.arr_FV = {
                    AT: null,
                    RS: null,
                    AGI: null,
                    CI: null,
                    AGI_csv: "",
                    AGI: null
                };

                this.$router.replace({
                    path: this.$route.path,
                    query: {}
                });

                if (sessionStorage.getItem('OVWL1_Filter_Month') != null && sessionStorage.getItem('OVWL1_Filter_Month') != '')
                {
                    this.arr_FV['DR'] = sessionStorage.getItem('OVWL1_Filter_Month');
                }

                if (sessionStorage.getItem('OVWL1_Filter_CI') != null && sessionStorage.getItem('OVWL1_Filter_CI') != '')
                {
                    this.arr_FV["CI"] = sessionStorage.getItem('OVWL1_Filter_CI');
                }

                if (sessionStorage.getItem('OVWL1_Filter_RS') != null && sessionStorage.getItem('OVWL1_Filter_RS') != '') {
                    this.arr_FV["RS"] = sessionStorage.getItem('OVWL1_Filter_RS');
                }

                if (sessionStorage.getItem('OVWL1_Filter_AGI_csv') != null && sessionStorage.getItem('OVWL1_Filter_AGI_csv') != '') {
                    this.arr_FV["AGI_csv"] = sessionStorage.getItem('OVWL1_Filter_AGI_csv');
                }

                if (sessionStorage.getItem('OVWL1_Filter_AGI') != null && sessionStorage.getItem('OVWL1_Filter_AGI').length > 0) {
                    this.SMList = sessionStorage.getItem('OVWL1_Filter_AGI');
                    this.arr_FV['AGI'] = this.SMList ? this.SMList.split(",") : [];
                }


                if (sessionStorage.getItem('OVWL1_Filter_AT') != null && sessionStorage.getItem('OVWL1_Filter_AT') != '') {
                    this.arr_FV['AT'] = sessionStorage.getItem('OVWL1_Filter_AT');
                }


                sessionStorage.setItem('OVWL1_Filter_T', false);
                sessionStorage.setItem('OVWL2_Filter_T', false);

                this.getPromotionReportList();


                this.backURL = null;

            },
            getMALevelStorage() {
                if (sessionStorage.getItem('OVWL2_Filter_Month') != null && sessionStorage.getItem('OVWL2_Filter_Month') != '') {
                    this.arr_FV['DR'] = sessionStorage.getItem('OVWL2_Filter_Month');
                }

                if (sessionStorage.getItem('OVWL2_Filter_CI') != null && sessionStorage.getItem('OVWL2_Filter_CI') != '') {
                    this.arr_FV["CI"] = sessionStorage.getItem('OVWL2_Filter_CI');
                }

                if (sessionStorage.getItem('OVWL2_Filter_RS') != null && sessionStorage.getItem('OVWL2_Filter_RS') != '') {
                    this.arr_FV["RS"] = sessionStorage.getItem('OVWL2_Filter_RS');
                }

                if (sessionStorage.getItem('OVWL2_Filter_AGI_csv') != null && sessionStorage.getItem('OVWL2_Filter_AGI_csv') != '') {
                    this.arr_FV["AGI_csv"] = sessionStorage.getItem('OVWL2_Filter_AGI_csv');
                }

                if (sessionStorage.getItem('OVWL2_Filter_AT') != null && sessionStorage.getItem('OVWL2_Filter_AT') != '') {
                    this.arr_FV['AT'] = sessionStorage.getItem('OVWL2_Filter_AT');
                }

                if (sessionStorage.getItem('OVWL2_Filter_AGI') != null && sessionStorage.getItem('OVWL2_Filter_AGI') != '') {
                    this.SMList = sessionStorage.getItem('OVWL2_Filter_AGI');
                    this.arr_FV['AGI'] = this.SMList ? this.SMList.split(",") : [];
                }

                sessionStorage.setItem('OVWL2_Filter_T', false);
                this.getPromotionReportList();


                if (this.backURL == 2) {
                    this.backURL = 1;
                }else {
                    this.backURL = null;
                }

            },
            renderStatus(statusCode) {
                if (statusCode == 2) {
                    return this.getLanguage['ACM']['NS'];
                } else if (statusCode == 4) {
                    return this.getLanguage['ACM']['SO'];
                }
            },
            renderRejectReason(rejectReason) {
                const found = constRejectReasonP.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constRejectReasonP) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            renderPromotionCode(promotionCode, commissionType) {
                if (commissionType == 1) {
                    return this.getLanguage["PM"]["TOCM"];
                }
                else if (commissionType == 2) {
                    return this.getLanguage["PM"]["WLCM"];
                }
                return promotionCode;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }
            },

            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {

            },

            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

            renderClassName(header, data) {
                 if (header == 'CFA' || header == 'SMMF' || header == 'QTY'|| header == 'IN') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;


                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },

            loadCurrencyOptions() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                            that.str_showDetails = (that.str_showDetails ? that.str_showDetails : that.ddCurrencyList[i].label);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS7';
            this.$parent.showActiveMenu = 'R.OVW';
            if (this.$route.path !== "/R/OVW" || Object.keys(this.$route.query).length !== 0) {
                this.$router.replace({ path: "/R/OVW", query: {} });
            }

            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.loadCurrencyOptions();
            this.getDropdownList();
            this.getVDP();

            this.getCurrencyList();

            this.arr_FV['DR'] = moment(new Date(new Date().getFullYear(), new Date().getMonth() - 1));
            this.getPromotionReportList();



        },
        watch: {
            getLanguage() {
                this.getPromotionReportList();
                this.getVDP();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/OverviewReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }


                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/OverviewReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>
<style>
    .month-picker-panel,
    .flexbox.monthItem,
    .date-popover {
        /* Remove position: absolute if the library handles positioning */
        /* position: absolute;  <-- remove this line */
        z-index: 999999 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/AccountOverviewReport.vue